import React, { useState, useCallback } from 'react'
import styles from '../styles.module.scss'
import ScheduleTable from '../../../components/ScheduleTable'
import Modal from 'react-responsive-modal'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import { useFormik } from 'formik'
import { Input, Select, Textarea } from '../../../components/ModalInputs'
import Button from '../../../components/Button'
import { useSelector } from 'react-redux'
import Confirmation from '../../../components/Confirmation/Confirmation'


export default function Table () {
  

  const { data, loading } = useSelector(state => state.scheduling)

  const [editCell, setEditCell] = useState(null)

  const handleCellDoubleClick = (cellData) => setEditCell(cellData)

  const closeModal = () => setEditCell(null)

  return (
    <div className={styles.wrapperTable}>
      
      <ScheduleTable
        schedule={data || []}
        loading={loading}
        onCellDoubleCLick={handleCellDoubleClick}
        handleExportToExcel={() => {}}
      /> 

      <EditModal
        open={!!editCell}
        data={editCell}
        closeModal={closeModal}
      />

    </div>
  )
}



const EditModal = ({open, closeModal, data}) => {

  const [confirmClose, setConfirmClose] = useState(false)
  const handleClose = useCallback(() => setConfirmClose(true), [])
  const acceptConfirmation = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
  const rejectConfirmation = useCallback(() => setConfirmClose(false), [])

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeOnEsc={true}
      closeOnOverlayClick={true}
      showCloseIcon={false}
    >
      <Tabs>

        <TabList className={styles.tabsBlock}>
            {data?.map((_, ind) => <Tab className={styles.tab} selectedClassName={styles.activeTab}>{`Предмет ${ind + 1}`}</Tab>)}
        </TabList>

        {data?.map((course, ind) =>
          <TabPanel key={ind}>
            <CourseTab data={course} closeModal={closeModal}/>
          </TabPanel>
        )}

      </Tabs>
      {confirmClose && (
        <Confirmation
          title="Закрыть без сохранения изменений?"
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
    </Modal>
  )
}

const CourseTab = ({ data, closeModal }) => {
  
  const {
    values,
    errors,
    handleChange,
    handleSubmit
  
  } = useFormik({
    initialValues: data,
    onSubmit: () => {}
  })

  return (
      <form className={styles.courseForm} onSubmit={handleSubmit}>
        <Input label='Класс' value={values.groupname} disabled/>
        <Input label='Урок' value={`${values.periodname} (${values.periodtime})`} disabled/>
        <Select label='Предмет' />
        <Select label='Класс / Подгруппа' />
        <Select label='Преподаватель' />
        <Select label='Аудитория' />
        <Select label='Статус занятия' />
        <Textarea label='Примечание' />
        <div className={styles.buttonsBlock}>
          <Button>Сохранить</Button>
          <Button onClick={closeModal}>Отмена</Button>
        </div>
      </form>
  )
}